import { Switch } from "antd";
import { Fragment } from "react";
import hasPermission from "../PermissionHocs/hasPermission";
import { permissions } from "../../constants/perrmission";

const SwitchWithPermission = (props) => {
  const {
    children,
    actions,
    key,
    type,
    danger,
    size,
    color,
    icon,
    style,
    hideOnNoPermission = false,
    noPermissionText,
    noPermissionClassName,
    ...rest
  } = props;

  const accessible = hasPermission({
    permissions: permissions,
    actions: actions,
  });
  return (
    <Fragment>
      {hideOnNoPermission && !accessible ? (
        <></>
      ) : (
        <Switch
          {...rest}
          type={type ?? "primary"}
          children={children}
          disabled={props.disabled || !accessible}
          key={key}
          danger={danger ?? false}
          size={size}
          icon={icon}
          color={color}
          style={style}
          tabIndex={-1}
        />
      )}
    </Fragment>
  );
};
export default SwitchWithPermission;
